/**
 * @desc 保存
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.Response;
export function request(body: defs.rms.PaymentBankRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentBank/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
